const question1 = {
    'question': 'Kiedy warto udać się do seksuologa?',
    'answer': 'Warto udać się do seksuologa, gdy doświadczamy problemów związanych z seksualnością, które wpływają negatywnie na nasze życie osobiste, zawodowe lub społeczne. Do najczęstszych problemów, z którymi zgłaszają się pacjenci do seksuologa należą: bolesne współżycie, zaburzenia orgazmu, problemy z libido, problemy z tożsamością płciową, orientacją seksualną.',
}

export default question1;